module.exports = __webpack_public_path__ + "img/invite_patient.64d7d0a4.png";